import LoginImg from "../../src/assets/images/logInImg.png";
import AuthForm from "../features/auth/AuthForm";

const Login = () => {
  return (
    <AuthForm
      type="login"
      title="Welcome "
      subtitle="Login with your mobile number to continue"
      image={LoginImg}
      redirectOnSuccess="/dashboard/myspace"
      // footerText="Don’t have an account?"
      // footerLink="Sign Up"
      // footerPath="/sign-up"
      userType="CUSTOMER"
      // userType="SUPER_ADMIN"
    />
  );
};

export default Login;
